var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgList = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17718_42054)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_17718_42054",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 1,
    stroke: "#43927C",
    strokeWidth: 2.4,
    mask: "url(#path-1-inside-1_17718_42054)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_17718_42054",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 4,
    height: 4,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 4,
    height: 4,
    rx: 1,
    stroke: "#43927C",
    strokeWidth: 2.4,
    mask: "url(#path-2-inside-2_17718_42054)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_17718_42054",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 4,
    height: 4,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 4,
    height: 4,
    rx: 1,
    stroke: "#43927C",
    strokeWidth: 2.4,
    mask: "url(#path-3-inside-3_17718_42054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 2L15 2",
    stroke: "#43927C",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8L15 8",
    stroke: "#43927C",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 14L15 14",
    stroke: "#43927C",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17718_42054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgList, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/list.a503dab1.svg";
export { ForwardRef as ReactComponent };